<style lang="less" scoped>
@import url('../../../style/common/variable.less');
@media screen and (min-width: @max-screen)
{
  .box{width: 1140px;}
  h2{text-align: left;margin-left: 15px;letter-spacing: 2px;}
  .leftBox{width: 350px;float: left;margin-left: 15px;margin-right: 0px;}
  .titleCard{width: 330px;}
}

@media screen and (max-width: @max-screen)
{
  h2{width: 100%;}
  .box{width: 100%;}
  .leftBox{width: 90%;margin: auto;}
  .titleCard{width: 100%;}
}

.kyxmDetails{position: relative;width: 100%;flex-direction: row;justify-content:space-between;margin: 0;padding: 0;background: #fff;font-family: Microsoft YaHei;margin-bottom: 40px;}
.box{margin:auto;}
.titleCard, .editorCard, .InfoCard, .InteresCard, .aPic, .pics{background-color: #ffffff;box-shadow: 0px 0px 3px 2px rgb(240, 239, 239);border-radius: 5px;text-align: left;}
.titleCard{height: 335px;margin-bottom: 24px;
  ul{list-style: none;margin-top: -10px;margin-left: -40px;}
  li{width:320px;margin: 12px 0px;}
  li:nth-child(3){width:320px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  li:nth-child(5){width:320px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .left{font-weight: 600;}
}
.editorCard{width: 330px;height: 400px;
  ul{list-style: none;margin-top: -10px;margin-left: -40px;}
  li{width:320px;margin: 12px 0px;}
  li:nth-child(3){width:320px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  li:nth-child(5){width:320px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .left{font-weight: 600;}
  .iconwei{color: rgb(209, 24, 24);margin: 0px 5px;}
  .iconyi{color: rgb(43, 214, 27);margin: 0px 5px;}
  .el-button{width: 140px;height: 42px;margin-left:88px;font-size: 16px;border-radius: 5px;box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.16);margin-top: 30px;}
}
.rightBox{width: 760px;display: flex;flex-direction: column;justify-content:center;align-items:center;}
.InfoCard{width: 750px;margin-bottom: 24px;
  .content{height: 602px;overflow: hidden;}
  .el-button{width: 140px;height: 42px;margin-left:320px;font-size: 16px;border-radius: 5px;box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.16);margin-top: 20px;}
}
.InteresCard{width: 750px;height: 265px;position: relative;
  ul{list-style: none;display: flex;margin-left: -50px;margin-top: -10px;margin-bottom: 0px;}
  li{width: 170px;height: 120px;margin-right: 14px;background-color: rgb(240, 239, 239);}
  li:hover{box-shadow: 0px 0px 3px 1px rgb(228, 227, 227);cursor: pointer;}
  li:hover img {opacity:0.8;}
  .pic{width: 170px;height: 90px;overflow:hidden;}
  .title{font-size: 14px;width: 150px;height: 40px;margin-left:10px;margin-top: 0px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .title:hover{color: #13569e;}
  .current{display: none;}
  .el-button{position: absolute;top:210px;left: 330px;width: 120px;height: 42px;font-size: 16px;border-radius: 5px;box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.16);}
}
</style>

<template>
  <div class="kyxmDetails">
    <div class="box">
      <h2> {{ infoObj.title }} </h2>
      <div class="leftBox">
        <el-card class="titleCard">
          <div slot="header" class="clearfix">
            <span>项目名称</span>
          </div>
          <ul class="content">
            <li><span class="left">项目类型：</span><span class="right"> {{ infoObj.text1 | formatXMLB() }} </span></li>
            <li><span class="left">主要矿种：</span><span class="right"> {{ infoObj.text2 }} </span></li>
            <li><span class="left">资源储量：</span><span class="right"> {{ infoObj.text3 }} </span></li>
            <li><span class="left">地理位置：</span><span class="right"> {{ infoObj.text4 }} </span></li>
            <li><span class="left">矿区面积：</span><span class="right"> {{ infoObj.text5 }} </span></li>
            <li><span class="left">合作方式：</span><span class="right"> {{ infoObj.text6 }} </span></li>
            <li><span class="left">更新时间：</span><span class="right"> {{ infoObj.text7 }} </span></li>
          </ul>
        </el-card>
        <el-card class="editorCard">
          <div slot="header" class="clearfix">
            <span>信息发布者</span>
          </div>
          <ul class="content">
            <li v-if="infoObj.text8 === '0'"><span class="left">认&nbsp;&nbsp; 证：</span><span class="iconwei"><i class="iconfont icon-weirenzheng" /></span>未认证</li>
            <li v-if="infoObj.text8 === '1'"><span class="left">认&nbsp;&nbsp; 证：</span><span class="iconyi"><i class="iconfont icon-yirenzheng" /> </span>已认证</li>
            <li><span class="left">联系人：</span><span class="right"> {{ infoObj.text9 }} </span></li>
            <li><span class="left">电&nbsp;&nbsp; 话：</span><span class="right"> {{ infoObj.text10 }} </span></li>
            <li><span class="left">手&nbsp;&nbsp; 机：</span><span class="right"> {{ infoObj.text11 }} </span></li>
            <li><span class="left">地&nbsp;&nbsp; 区：</span><span class="right"> {{ infoObj.text12 | formatGJ() }} </span></li>
            <li><span class="left">地&nbsp;&nbsp; 址：</span><span class="right"> {{ infoObj.text13 }} </span></li>
          </ul>
          <el-button type="primary" @click="gotoCompany">查看企业详情</el-button>
        </el-card>
      </div>
      <div class="rightBox" v-if="ifShowFlag">
        <el-card class="InfoCard">
          <div slot="header" class="clearfix">
            <span>项目信息</span>
          </div>
          <div class="content" v-html="curContent"></div>
          <el-button type="primary" v-if="!show" @click="lookmore">查看更多</el-button>
          <el-button type="primary" v-if="show" @click="lookmore">收起</el-button>
        </el-card>
        <el-card class="InteresCard">
          <div slot="header" class="clearfix">
            <span>猜你喜欢</span>
          </div>
          <div class="picBox">
            <ul>
              <li v-for="(item,index) in datalist" :key="index" @click="clickPic(item)">
                <img class="pic" :src="item.pic">
                <p class="title"> {{ item.title }} </p>
              </li>
            </ul>
            <p class="current"> {{ current }} </p>
          </div>
          <el-button type="primary" @click="changePic">加载更多</el-button>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 何宽 合作项目下的矿业项目专场详细信息页面
 */
import filters from '../method/filter.js'
import $ from 'jquery'
export default {
  name: '',
  mixins: [filters],
  data()
  {
    return {
      infoObj: {},
      curContent: null,
      interestedList: [],
      show: false,
      current: 0,  // 点击加载更多的次数
      datalist: [], // 猜你喜欢数据临时存储容器
      companyID: null, // 公司ID
      ifShowFlag: true
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.getCompany(nval.query.company)
        this.getdata(+nval.query.id)
      },
      immediate: true
    }
  },

  mounted()
  {
    if (window.innerWidth > 912)
      this.ifShowFlag = true
    else
      this.ifShowFlag = false
  },

  methods:
  {
    // 获取项目信息
    getdata(num)
    {
      let paras1 = {cmd: 'query', _major: 11, _minor: 12, _exp: 'id=?', types: 'i', vals: num}
      window.post.getPost(paras1).then((ret) =>
      {
        this.infoObj = {title: ret[0].title, text1: ret[0].xiangmuleibie, text2: ret[0].kanchakuangzhong, text3: ret[0].ziyuanchuliang, text4: ret[0].diliweizhi, text5: ret[0].mianji, text6: ret[0].hezuofangshi, text7: ret[0].editdate, text8: ret[0].validated, text9: ret[0].truename, text10: ret[0].telephone, text11: ret[0].mobile, text12: ret[0].ssgj, text13: ret[0].address}
      })
      let paras2 = {cmd: 'query', _major: 11, _minor: 13, _exp: 'id=?', types: 'i', vals: num}
      window.post.getPost(paras2).then((ret) =>
      {
        this.curContent = window.public.decodeContent(ret[0].content)
      })
      let paras3 = {cmd: 'query', _major: 11, _minor: 12, _exp: 'examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 100}
      window.post.getPost(paras3).then((ret) =>
      {
        let temp = []
        ret[0].data.forEach(item =>
        {
          temp.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', company: item.company})
        })
        this.interestedList = temp
        this.changePic()
      })
    },
    // 获取公司id
    getCompany(str)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 26, _exp: `company='${str}'`}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length === 1)
          this.companyID = ret[0].id
      })
    },
    gotoCompany()
    {
      let url = this.$router.resolve({path: '/CompanyShow', query: {id: this.companyID}})
      window.open(url.href, '_blank')
    },
    // 当前信息过多时，点击查看更多进行展示
    lookmore()
    {
      this.show = !this.show
      if (this.show)
      {
        $('.InfoCard .content').css('height', 'auto')
        $('.InfoCard .content').css('min-height', '602px')
      }
      else
        $('.InfoCard .content').css('height', '602px')
    },
    // 加载更多
    changePic()
    {
      this.current += 1
      if (this.interestedList.length - this.current * 4 > 0)
      {
        for (let i = 0; i < 4; i++)
          this.datalist[i] = this.interestedList[i + (this.current - 1) * 4]
      }
      else
      {
        if (this.interestedList.length - this.current * 4 > -4)
        {
          for (let i = 0; i < this.interestedList.length - (this.current - 1) * 4; i++)
            this.datalist[i] = this.interestedList[i + (this.current - 1) * 4]
          for (let i = this.interestedList.length - (this.current - 1) * 4; i < 4; i++)
            this.datalist[i] = this.interestedList[i - 1]
        }
        else
        {
          for (let i = 0; i < 4; i++)
            this.datalist[i] = this.interestedList[i]
          this.current = 0
        }
      }
    },
    clickPic(item)
    {
      let url = this.$router.resolve({path: '/HzxmKYXMDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/HzxmKYXMDetails.vue